module.exports = __webpack_public_path__ + "img/policy.475be4ed.svg";